import React, { createContext, useContext, useReducer, PropsWithChildren } from 'react';
import {
  OfficialDailyDetailReducer,
  initialState,
  OfficialDailyDetailState,
  OfficialDailyDetailAction
} from './official-daily-detail-reducer';

const OfficialDailyDetailStateContext = createContext<OfficialDailyDetailState | undefined>(undefined);
const OfficialDailyDetailDispatchContext = createContext<React.Dispatch<OfficialDailyDetailAction> | undefined>(undefined);

export const OfficialDailyDetailProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [state, dispatch] = useReducer(OfficialDailyDetailReducer, initialState);

  return (
    <OfficialDailyDetailStateContext.Provider value={state}>
      <OfficialDailyDetailDispatchContext.Provider value={dispatch}>
        {children}
      </OfficialDailyDetailDispatchContext.Provider>
    </OfficialDailyDetailStateContext.Provider>
  );
};

export const useOfficialDailyDetailState = (): OfficialDailyDetailState => {
  const context = useContext(OfficialDailyDetailStateContext);
  if (context === undefined) {
    throw new Error('useOfficialDailyDetailState must be used within a OfficialDailyDetailProvider');
  }
  return context;
};

export const useOfficialDailyDetailDispatch = (): React.Dispatch<OfficialDailyDetailAction> => {
  const context = useContext(OfficialDailyDetailDispatchContext);
  if (context === undefined) {
    throw new Error('useOfficialDailyDetailDispatch must be used within a OfficialDailyDetailProvider');
  }
  return context;
};
